import React, { useState } from "react"
import {
  addressItemAddress,
  addressItemName,
  addressItemTitle,
  addressItemContacts,
  addressItemTel,
  addressItemMail,
  addressItemMailObfuscate,
  addressItemMailMobile,
  addressItemTooltip,
  addressItemTooltipMobile,
  addressMore,
  pasteButton,
  pasteButtonImg,
} from "../carnet-adresse.module.scss"
import {
  AddressTitle,
  StyledLink,
  StyledLinkContainer,
  MailButton,
} from "./address-content-styled"
import PropTypes from "prop-types"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import Obfuscate from "react-obfuscate"
import paste from "gatsby-theme-blank/src/images/paste.png"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"

const AddressContent = ({ address }) => {
  const [emailVisible, setEmailVisible] = useState(false)
  return (
    <>
      <TransitionFade className={addressItemName} link={address.path.alias}>
        <AddressTitle className={addressItemTitle}>
          {address.title}
        </AddressTitle>
        <div className={addressItemAddress}>
          <p>{address.field_adresse?.address_line1}</p>
          <p>{address.field_adresse?.address_line2}</p>
          <p>
            {address.field_adresse?.postal_code}{" "}
            {address.field_adresse?.locality}
          </p>
        </div>
      </TransitionFade>
      {address.field_telephone && (
        <Obfuscate tel={address.field_telephone} className={addressItemTel} />
      )}
      <div className={addressItemContacts}>
        {!address.field_mail ? null : (
          <>
            <StyledLinkContainer className={addressItemMail}>
              <Obfuscate
                email={address.field_mail}
                className={addressItemMailObfuscate}
                aria-label={"Contacter par mail"}
              >
                <Icon size={28} icon="mail"></Icon>
              </Obfuscate>
            </StyledLinkContainer>
            <div className={addressItemTooltip}>
              <button
                className={pasteButton}
                onClick={(event) => {
                  event.preventDefault()
                  navigator.clipboard.writeText(address.field_mail)
                  alert("Email copié avec succès")
                }}
              >
                <img
                  alt="copiercoller"
                  className={pasteButtonImg}
                  src={paste}
                />
              </button>
            </div>
            <p
              role="presentation"
              onClick={() => setEmailVisible(true)}
              onKeyDown={() => setEmailVisible(true)}
              className={addressItemMailMobile}
            >
              {emailVisible === true && (
                <MailButton
                  style={{ textAlign: "left" }}
                  className={addressItemTooltipMobile}
                >
                  <Obfuscate
                    email={address.field_mail}
                    className={addressItemMailObfuscate}
                    aria-label={"Contacter par mail"}
                  />
                </MailButton>
              )}
            </p>
          </>
        )}
        <StyledLink
          className={addressMore}
          link={address.path.alias}
          arialabel={address.title}
        >
          <Icon size={24} icon="info"></Icon>
        </StyledLink>
      </div>
    </>
  )
}

AddressContent.propTypes = {
  address: PropTypes.object.isRequired,
}

export default AddressContent
